export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M15.504 5.92a.75.75 0 0 1 1.06-.035l4.204 3.937a.753.753 0 0 1 .01 1.085l-4.204 4.094a.75.75 0 0 1-1.046-1.074l2.883-2.807H7.745a3.25 3.25 0 0 0-3.25 3.25v3.197a.75.75 0 0 1-1.5 0V14.37a4.75 4.75 0 0 1 4.75-4.75h10.611l-2.818-2.64a.75.75 0 0 1-.034-1.06Z"/>
</svg>
`;
